import React from 'react';
import { Link } from 'react-router-dom';

const latestItems = [
  {
    category: "AI Law",
    title: "Understanding Machine Learning Legal Frameworks in Africa",
    image: "https://images.unsplash.com/photo-1677442136019-21780ecad995?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "/sectors/machine-learning",
    categoryColor: "bg-primary"
  },
  {
    category: "News",
    title: "Corporate Governance & Technology: Navigating the Digital Transformation",
    image: "https://images.unsplash.com/photo-1507679799987-c73779587ccf?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "/corporate-governance-tech",
    categoryColor: "bg-secondary"
  },
  {
    category: "Insights",
    title: "The Rise of Agentic AI: Legal Implications for African Businesses",
    image: "https://images.unsplash.com/photo-1485827404703-89b55fcc595e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    link: "/sectors/agentic-ai",
    categoryColor: "bg-amber-600"
  }
];

const LatestUpdatesSection = () => {
  return (
    <section className="bg-white py-16">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-3xl md:text-4xl font-bold text-primary text-center mb-12">
          Latest from Law and Code Africa
        </h2>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {latestItems.map((item, index) => (
            <Link 
              key={index} 
              to={item.link}
              className="group block"
            >
              <div className="relative overflow-hidden rounded-lg shadow-md hover:shadow-xl transition-shadow duration-300">
                <div className="aspect-[4/3] overflow-hidden">
                  <img 
                    src={item.image} 
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                  />
                </div>
                <span className={`absolute top-4 left-4 ${item.categoryColor} text-white px-4 py-1 rounded-full text-sm font-medium`}>
                  {item.category}
                </span>
              </div>
              <h3 className="mt-4 text-lg font-semibold text-gray-800 group-hover:text-primary transition-colors duration-200 text-center">
                {item.title}
              </h3>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
};

export default LatestUpdatesSection;
